import { Typography } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import ActionButton from "components/Buttons/ActionButton";
import EmailField from "components/EmailField";
import useNotifications from "features/Notifications/hooks/useNotifications";
import useSendParticipantPin from "hooks/api/useSendParticipantPin";
import { useEffect, useState } from "react";

function ForgotPin() {
  const [email, setEmail] = useState<string | undefined>();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { setNotification } = useNotifications();
  const { sendParticipantPin } = useSendParticipantPin();

  useEffect(() => {
    setIsSubmitted(false);
  }, [email]);

  async function onSubmit() {
    if (!email) return;
    setIsSubmitted(true);
    const response = await sendParticipantPin(email);
    if (response === "OK") {
      setNotification({
        message:
          "You'll receive an email with your pin, if the email is valid.",
        severity: "success",
        autoHideDuration: undefined,
      });
    }
    setIsSubmitted(false);
  }

  return (
    <Grid container flexDirection="column" spacing={1}>
      <Grid item xs={12} sx={{ mb: 2 }}>
        <Typography
          variant="h6"
          sx={{ width: "100%", textAlign: "center", pr: "2.5rem", pb: "1rem" }}
        >
          Recover PIN
        </Typography>
        <EmailField
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <ActionButton
          disabled={!email || isSubmitted}
          fullWidth
          onClick={onSubmit}
        >
          Submit
        </ActionButton>
      </Grid>
    </Grid>
  );
}

export default ForgotPin;
